import { render, staticRenderFns } from "./customer-account.vue?vue&type=template&id=a759ecd8&"
import script from "./customer-account.vue?vue&type=script&lang=js&"
export * from "./customer-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports